import React, { useState } from 'react';
import { Dialog, Box, Typography, Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CommonImages from '../../../commons/images';
import * as styles from './styles';

const SHARE_URL = 'https://ecal.world/';
const SHARE_MESSAGE = `I've just synced my fave events to my calendar via @ecalworld, you can too! ${SHARE_URL}`;

const SHARE_BUTTONS = [
    {
        label: 'WhatsApp',
        href: `https://wa.me/?text=${encodeURIComponent(SHARE_MESSAGE)}`,
    },
    {
        label: 'Twitter / X',
        href: `https://twitter.com/intent/tweet?text=${encodeURIComponent(SHARE_MESSAGE)}`,
    },
    {
        label: 'Facebook',
        href: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(SHARE_URL)}&quote=${encodeURIComponent(SHARE_MESSAGE)}`,
    },
    {
        label: 'Email',
        href: `mailto:?subject=${encodeURIComponent('Sync your favourite events to your calendar with ECAL')}&body=${encodeURIComponent(SHARE_MESSAGE)}`,
    },
];

function ShareDialog({ open, onClose }) {
    const [copied, setCopied] = useState(false);

    function handleCopyLink() {
        navigator.clipboard.writeText(SHARE_URL).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 1800);
        }).catch(() => {});
    }

    function renderCloseButton() {
        return (
            <Box component="button" onClick={onClose} aria-label="Close" sx={styles.closeButton}>
                <CloseIcon sx={{ fontSize: 16 }} />
            </Box>
        );
    }

    function renderHeader() {
        return (
            <Box sx={styles.header}>
                <Box component="img" src={CommonImages.ECAL_SYMBOL} alt="ECAL" sx={styles.logo} />
                <Typography sx={styles.title}>Share ECAL World</Typography>
            </Box>
        );
    }

    function renderDescription() {
        return (
            <Typography sx={styles.description}>
                Tell a friend about ECAL — discover and sync the world's best brands to your personal digital calendar.
            </Typography>
        );
    }

    function renderMessageBox() {
        return (
            <Box sx={styles.messageBox}>
                "{SHARE_MESSAGE}"
            </Box>
        );
    }

    function renderShareButton({ label, href }) {
        return (
            <Box key={label} sx={styles.shareButtonWrapper}>
                <Box
                    component="a"
                    href={href}
                    target="_blank"
                    rel="noreferrer noopener"
                    sx={styles.shareButton}
                >
                    {label}
                </Box>
            </Box>
        );
    }

    function renderShareButtons() {
        return (
            <Box sx={styles.buttonsGrid}>
                {SHARE_BUTTONS.map(renderShareButton)}
            </Box>
        );
    }

    function renderCopyButton() {
        return (
            <Box component="button" onClick={handleCopyLink} sx={styles.copyButton}>
                {copied ? 'Link copied!' : 'Copy link'}
            </Box>
        );
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth={false}
            aria-label="Share ECAL World"
            sx={styles.dialog}
            slotProps={{ backdrop: { sx: styles.backdrop } }}
        >
            {renderCloseButton()}
            {renderHeader()}
            {renderDescription()}
            {renderMessageBox()}
            {renderShareButtons()}
            {renderCopyButton()}
        </Dialog>
    );
}

export default ShareDialog;
